import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

import Uuid from '../../../../../support/Uuid';
import AerolineasCargoForm from './AerolineasCargoForm';
import AerolineasCargoList from './AerolineasCargoList';
import { FormControl } from '../../../../../facturotopia';
import AerolineasOtrosCargosCalculator from '../../../support/aerolineas/AerolineasOtrosCargosCalculator';

class AerolineasCargoManager extends Component {
  state = {};

  get rules() {
    return {};
  }

  handleOnAdd = (data) => {
    const { OtrosCargos = {} } = this.props.data;
    const { Cargo = [] } = OtrosCargos;

    const newData = Cargo.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newData);
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  handleOnListChange = (data) => {
    const calc = AerolineasOtrosCargosCalculator.make(data).get();

    this.props.onChange({
      ...this.props.data,
      OtrosCargos: {
        TotalCargos: calc.TotalCargos,
        Cargo: data
      }
    });
  }

  render() {
    const { data } = this.state;
    const rules = this.rules;
    const { OtrosCargos = {} } = this.props.data;
    const { Cargo = [] } = OtrosCargos;

    return (
      <>
        <div className="pb-4">
          <div className="section pt-2">
            <AerolineasCargoForm
              data={ data }
              onAdd={ this.handleOnAdd }
            />

            <div className="pt-2">
              <AerolineasCargoList
                data={ Cargo }
                onEdit={ this.handleOnEdit }
                onChange={ this.handleOnListChange }
              />
            </div>

            <div>
              <strong className="text-muted">
                Resumen de cargos
              </strong>
            </div>

            <Row>
              <Col sm md={ 4 }>
                <FormControl type="number"
                  label="Total cargos"
                  name="TotalCargos"
                  placeholder=""
                  help=""
                  min="0"
                  rules={ rules.TotalCargos }
                  value={ OtrosCargos.TotalCargos }
                  onChange={ this.handleOnChange }
                />
              </Col>
            </Row>
          </div>
        </div>
      </>
    )
  }
}

export default AerolineasCargoManager;